import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { MessageSquare, Calendar, CalendarDays, CalendarRange } from 'lucide-react';

interface MessageStats {
  total: number;
  today: number;
  thisWeek: number;
  thisMonth: number;
}

interface GlobalMessageStatsProps {
  stats: MessageStats | undefined;
  isLoading?: boolean;
}

function formatNumber(num: number): string {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toString();
}

export function GlobalMessageStats({ stats, isLoading }: GlobalMessageStatsProps) {
  const items = [
    {
      label: 'Total',
      value: stats?.total || 0,
      icon: MessageSquare,
      description: 'Todas as mensagens',
    },
    {
      label: 'Hoje',
      value: stats?.today || 0,
      icon: Calendar,
      description: 'Mensagens de hoje',
    },
    {
      label: 'Esta Semana',
      value: stats?.thisWeek || 0,
      icon: CalendarDays,
      description: 'Últimos 7 dias',
    },
    {
      label: 'Este Mês',
      value: stats?.thisMonth || 0,
      icon: CalendarRange,
      description: 'Mês atual',
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MessageSquare className="h-5 w-5" />
          Volume de Mensagens Global
        </CardTitle>
        <CardDescription>Mensagens em toda a plataforma</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((item) => (
            <div key={item.label} className="space-y-1">
              <div className="flex items-center gap-2 text-muted-foreground">
                <item.icon className="h-4 w-4" />
                <span className="text-sm">{item.label}</span>
              </div>
              {isLoading ? (
                <Skeleton className="h-8 w-20" />
              ) : (
                <p className="text-2xl font-bold">{formatNumber(item.value)}</p>
              )}
              <p className="text-xs text-muted-foreground">{item.description}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
